<div class="col-12 col-sm-12 col-lg-12 text-center mt-5">
    <div class="row align-items-center trip-title text-center text-sm-center" style=" display: inline-flex;">
        <div class="col col-sm-auto text-center text-sm-left">
            <h6 class="m-0 trip-place">Please wait while we check the login details</h6>
        </div>
    </div>
</div>
<div class="col-12 col-sm-12 col-lg-12 text-center">
    <img src="./assets/images/progress.gif">
</div>